import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { Form, Grid, Header, List, Table } from 'semantic-ui-react'
import Section from '../Inputs/Section'
import Input from '../Inputs/Input'
import { runInAction } from 'mobx'
import { observer } from 'mobx-react'
import Checkbox from '../Inputs/Checkbox'
import TextArea from '../Inputs/TextArea'
import TableDnD from '../Inputs/TableDnD'
import Select from '../Inputs/Select'
import { DispositifList } from '../../../utils/FormSelectHelper'
import Duplicate from '../Inputs/Duplicate'

@observer
class RIA53604000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry)
  }

  tableList = [
    'qtyAG',
    'qtyAF',
    'qtyCC10',
    'qtyCL',
    'qtyCL6',
    'qtyCL10',
    'qtyCONT',
    'qtyRHT',
    'qtyDFI',
    'qtyDFP',
    'qtyDC',
    'qtyDUV',
    'qtyHT',
    'qtyDA',
    'qtyS',
    'qtyHP',
    'qtySP',
    'qtyID',
    'qtyIBP',
    'qtyIHP',
    'qtyIV',
    'qtyIPL',
    'qtyMR',
    'qtyIPA',
    'qtyPS',
    'qtyRV',
    'qtyKP',
    'qtyMAD',
    'qtyISO',
    'qtyPAI',
    'qtyANN',
    'qtyPAR',
    'qtyPZ2',
    'qtyPZ',
    'qtyRP',
    'qtyRelais',
    'qtyRFL',
    'qtyK',
    'qtySOL',
    'qtyA',
    'qtySM',
    'qtyTEL',
    'qtyBOOS'
  ]

  handleUpdateRegistryCount = () => {
    const { equipment } = this.props
    let newValue = 0
    for (const name of this.tableList) {
      const fieldValue = parseInt(equipment.getValue(name))
      if (Number.isInteger(fieldValue)) {
        newValue += fieldValue
      }
    }
    runInAction(() => {
      equipment.updateValue('totalEquipment', newValue)
    })
  }

  handleUpdateRegistryFromTableCount = () => {
    const { equipment } = this.props
    const rows = parseInt(equipment.getValue('tableRows', false, 0))
    const countValues = {}
    for (let i = 0; i < rows; i++) {
      const value = equipment.getValue(`dispositif_${i}`)
      if (value) {
        if (countValues[value] === undefined) { countValues[value] = 0 }
        countValues[value]++
      }
    }
    for (const [key, value] of Object.entries(countValues)) {
      runInAction(() => {
        equipment.updateValue(`qty${key}`, value)
      })
    }
    this.handleUpdateRegistryCount()
  }

  render () {
    const { equipment } = this.props
    return (
      <Form>
        <Section title={(<Header as='h2'>REGISTRE DES ÉQUIPEMENTS</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={2}>
                <Header as='h5'>DISPOSITIF</Header>
              </Grid.Column>
              <Grid.Column width={12}>
                <Header as='h5'>DESCRIPTION</Header>
              </Grid.Column>
              <Grid.Column width={2}>
                <Header as='h5'>QUANTITÉ</Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>AG</Grid.Column>
              <Grid.Column width={12}>Alarme générale</Grid.Column>
              <Grid.Column width={2}><Input name='qtyAG' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>AF</Grid.Column>
              <Grid.Column width={12}>Avertisseur de fumée</Grid.Column>
              <Grid.Column width={2}><Input name='qtyAF' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>CC10</Grid.Column>
              <Grid.Column width={12} />
              <Grid.Column width={2}><Input name='qtyCC10' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>CL</Grid.Column>
              <Grid.Column width={12}>Cloche</Grid.Column>
              <Grid.Column width={2}><Input name='qtyCL' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>CL6</Grid.Column>
              <Grid.Column width={12}>Cloche 6"</Grid.Column>
              <Grid.Column width={2}><Input name='qtyCL6' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>CL10</Grid.Column>
              <Grid.Column width={12}>Cloche 10"</Grid.Column>
              <Grid.Column width={2}><Input name='qtyCL10' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>CONT</Grid.Column>
              <Grid.Column width={12}>Contact sec</Grid.Column>
              <Grid.Column width={2}><Input name='qtyCONT' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>RHT</Grid.Column>
              <Grid.Column width={12}>Détecteur de chaleur thermovélocimétrique (température variable)</Grid.Column>
              <Grid.Column width={2}><Input name='qtyRHT' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>DFI</Grid.Column>
              <Grid.Column width={12}>Détecteur de fumée à ionisation</Grid.Column>
              <Grid.Column width={2}><Input name='qtyDFI' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>DFP</Grid.Column>
              <Grid.Column width={12}>Détecteur de fumée à photo électrique</Grid.Column>
              <Grid.Column width={2}><Input name='qtyDFP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>DC</Grid.Column>
              <Grid.Column width={12}>Détecteur de fumée de conduit</Grid.Column>
              <Grid.Column width={2}><Input name='qtyDC' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>DUV</Grid.Column>
              <Grid.Column width={12}>Détecteur ultraviolet d'étincelle</Grid.Column>
              <Grid.Column width={2}><Input name='qtyDUV' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>HT</Grid.Column>
              <Grid.Column width={12}>Détecteurs de chaleur thermostatique (fixe)</Grid.Column>
              <Grid.Column width={2}><Input name='qtyHT' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>DA</Grid.Column>
              <Grid.Column width={12}>Dispositif auxiliaire</Grid.Column>
              <Grid.Column width={2}><Input name='qtyDA' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>S</Grid.Column>
              <Grid.Column width={12}>Dispositif de signalisation visuelle</Grid.Column>
              <Grid.Column width={2}><Input name='qtyS' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>HP</Grid.Column>
              <Grid.Column width={12}>Haut-parleur</Grid.Column>
              <Grid.Column width={2}><Input name='qtyHP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>SP</Grid.Column>
              <Grid.Column width={12}>Haut-parleur à cône</Grid.Column>
              <Grid.Column width={2}><Input name='qtySP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>ID</Grid.Column>
              <Grid.Column width={12}>Interrupteur de débit des gicleurs</Grid.Column>
              <Grid.Column width={2}><Input name='qtyID' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>IBP</Grid.Column>
              <Grid.Column width={12}>Interrupteur de surveillance de basse pression des gicleurs</Grid.Column>
              <Grid.Column width={2}><Input name='qtyIBP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>IHP</Grid.Column>
              <Grid.Column width={12}>Interrupteur de surveillance de haute pression des gicleurs</Grid.Column>
              <Grid.Column width={2}><Input name='qtyIHP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>IV</Grid.Column>
              <Grid.Column width={12}>Interrupteur de surveillance de valve des gicleurs</Grid.Column>
              <Grid.Column width={2}><Input name='qtyIV' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>IFL</Grid.Column>
              <Grid.Column width={12}>Interrupteur faisceau lumineux de supervision cylindre</Grid.Column>
              <Grid.Column width={2}><Input name='qtyIPL' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>M/R</Grid.Column>
              <Grid.Column width={12}>Interrupteur maître / réserve</Grid.Column>
              <Grid.Column width={2}><Input name='qtyMR' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>IPA</Grid.Column>
              <Grid.Column width={12}>Interrupteur pneumatique d'alarme (Pressostat)</Grid.Column>
              <Grid.Column width={2}><Input name='qtyIPA' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>PS</Grid.Column>
              <Grid.Column width={12}>Interrupteur pneumatique de supervision de pression (Pressostat)</Grid.Column>
              <Grid.Column width={2}><Input name='qtyPS' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>KV</Grid.Column>
              <Grid.Column width={12}>Klaxon et signal visuel combinés</Grid.Column>
              <Grid.Column width={2}><Input name='qtyRV' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>KP</Grid.Column>
              <Grid.Column width={12}>Klaxon pneumatique</Grid.Column>
              <Grid.Column width={2}><Input name='qtyKP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>MAD</Grid.Column>
              <Grid.Column width={12}>Module adressable</Grid.Column>
              <Grid.Column width={2}><Input name='qtyMAD' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>ISO</Grid.Column>
              <Grid.Column width={12}>Module d'isolation en cas de défaut</Grid.Column>
              <Grid.Column width={2}><Input name='qtyISO' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>PAI</Grid.Column>
              <Grid.Column width={12}>Panneau d'alarme incendie</Grid.Column>
              <Grid.Column width={2}><Input name='qtyPAI' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>ANN</Grid.Column>
              <Grid.Column width={12}>Annonciateur</Grid.Column>
              <Grid.Column width={2}><Input name='qtyANN' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>PAR</Grid.Column>
              <Grid.Column width={12}>Panneau d'alarme pour relâche</Grid.Column>
              <Grid.Column width={2}><Input name='qtyPAR' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>PZ2</Grid.Column>
              <Grid.Column width={12}>Piezo silencable</Grid.Column>
              <Grid.Column width={2}><Input name='qtyPZ2' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>PZ</Grid.Column>
              <Grid.Column width={12}>Piezzo</Grid.Column>
              <Grid.Column width={2}><Input name='qtyPZ' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>RP</Grid.Column>
              <Grid.Column width={12}>Relâche pneumatique</Grid.Column>
              <Grid.Column width={2}><Input name='qtyRP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>Relais</Grid.Column>
              <Grid.Column width={12}>Relais</Grid.Column>
              <Grid.Column width={2}><Input name='qtyRelais' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>RFL</Grid.Column>
              <Grid.Column width={12}>Résistance fin de ligne</Grid.Column>
              <Grid.Column width={2}><Input name='qtyRFL' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>K</Grid.Column>
              <Grid.Column width={12}>Sirène du type klaxon</Grid.Column>
              <Grid.Column width={2}><Input name='qtyK' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>SOL</Grid.Column>
              <Grid.Column width={12}>Solénoide</Grid.Column>
              <Grid.Column width={2}><Input name='qtySOL' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>A</Grid.Column>
              <Grid.Column width={12}>Station d'avortement</Grid.Column>
              <Grid.Column width={2}><Input name='qtyA' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>SM</Grid.Column>
              <Grid.Column width={12}>Station manuelle</Grid.Column>
              <Grid.Column width={2}><Input name='qtySM' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>TEL</Grid.Column>
              <Grid.Column width={12}>Téléphone d'urgence</Grid.Column>
              <Grid.Column width={2}><Input name='qtyTEL' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>BOOS</Grid.Column>
              <Grid.Column width={12}>Booster</Grid.Column>
              <Grid.Column width={2}><Input name='qtyBOOS' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={14} verticalAlign='middle'><Header as='h4'>TOTAL</Header></Grid.Column>
              <Grid.Column width={2}><Input name='totalEquipment' formEntry={equipment} size='mini' /></Grid.Column>
            </Grid.Row>
          </Grid>
          <List bulleted>
            <List.Item>Les essais indiqués sur ce formulaire peuvent ne pas comprendre l'essai ou le fonctionnement des dispositifs auxiliaires</List.Item>
            <List.Item>Les avertisseurs de fumée autonomes ne font pas partie du réseau avertisseur d'incendie mais leur mise à l'essai peut être exigée par l'autorité compétente.</List.Item>
          </List>
        </Section>
        <Section title={(<Header as='h2'>RAPPORT D'INSPECTION ET DE MISE À L'ESSAI ANNUEL D'UN RÉSEAU AVERTISSEUR D'INCENDIE</Header>)}>
          <Input name='designationSystem' formEntry={equipment} label='Désignation du système' />
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={12}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>1</Grid.Column>
              <Grid.Column width={11}>Description du système affiché sur place</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes1' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no1' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>2</Grid.Column>
              <Grid.Column width={11}>Le système d'incendie fonctionne dans son intégrité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes2' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no2' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>3</Grid.Column>
              <Grid.Column width={11}>Le système d'incendie à des lacunes qui sont rapportées sur les pages ci-jointes (section #1)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes3' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no3' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>4</Grid.Column>
              <Grid.Column width={11}>Le système d'incendie comporte des recommandations qui sont rapportées sur les pages ci-jointes (section #2)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes4' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no4' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>5</Grid.Column>
              <Grid.Column width={11}>Le système d'incendie comporte des remarques rapportées sur les pages ci-jointes (section #3)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes5' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no5' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>6</Grid.Column>
              <Grid.Column width={15}>
                <Input name='copieRapport' formEntry={equipment} label='Une copie du rapport à été remise à' />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>7</Grid.Column>
              <Grid.Column width={11}>Un certificat de bon fonctionnement est remis</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes7' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no7' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
          <List bulleted>
            <List.Header><Header as='h5'>Mise en garde</Header></List.Header>
            <List.Item>Les essais rapportés dans le présent formulaire ne comprennent pas nécessairement la mise à l'essai des dispositifs auxiliaires</List.Item>
            <List.Item>La présente certifie que les renseignements contenus dans le rapport annuel d'inspection et de mise à l'essai du réseau avertisseur d'incendie sont corrects et complets</List.Item>
          </List>
        </Section>
        <Section title={(<Header as='h2'>RAPPORT ANNUEL DE MISE À L'ESSAI ET D'INSPECTION</Header>)}>
          <Form.Group widths='equal'>
            <Input name='fabricantReseau' formEntry={equipment} label='Fabicant du réseau' />
            <Input name='fabricantReseauModel' formEntry={equipment} label='Modèle' />
          </Form.Group>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={9}>Fonctionnement, une étape</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yesA' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='noA' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='soA' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={9}>Fonctionnement, deux étapes</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yesB' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='noB' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='soB' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={9}>Inspection et mise à l'essai de tout le réseau avertisseur d'incendie conformément à la norme CAN/ULC-S536, Inspection et mise à l'essai des réseaux avertisseurs d'incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yesC' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='noC' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='soC' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>D</Grid.Column>
              <Grid.Column width={9}>La documentation du réseau avertisseur d'incendie est sur place et comporte une description du réseau avertisseur d'incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yesD' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='noD' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='soD' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>E</Grid.Column>
              <Grid.Column width={9}>Le réseau surveillé est complètement en état de fonctionner</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yesE' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='noE' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='soE' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>F</Grid.Column>
              <Grid.Column width={9}>Le réseau avertisseur d'incendie présente des lacunes décrites sur les pages ci-jointes</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yesF' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='noF' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='soF' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>G</Grid.Column>
              <Grid.Column width={15}>
                <TextArea name='commentaireG' formEntry={equipment} rows={5} label='Commentaires' />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <TableDnD
            formEntry={equipment}
            tableProps={{ celled: true, compact: 'very', size: 'small', style: { minWidth: '800px!important' } }}
            totalRowLabel='tableRows'
            minimumRows={30}
            addRowLabel="Ajouter X nombre d'équipement supplémentaire"
            droppableKey='tableEquipment'
            headers={[{
              props: { style: { width: '30%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'emplacement',
              label: 'EMPLACEMENT'
            }, {
              props: { style: { width: '15%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'modele',
              label: 'MODÈLE'
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'installe',
              label: (<div className='table-vertical'>INSTALLÉ CONVENABLEMENT</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'manquant',
              label: (<div className='table-vertical'>MANQUANT</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'reparation',
              label: (<div className='table-vertical'>RÉPARATION NÉCESSAIRE</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'fonctionnement',
              label: (<div className='table-vertical'>FONCTIONNEMENT CONFIRMÉ</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'supervision',
              label: (<div className='table-vertical'>SUPERVISION CONFIRMÉ</div>)
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'dispositif',
              label: 'DISPOSITIF'
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'zone',
              label: 'ZONE OU ADRESSE'
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'sensibilite',
              label: 'SENSIBILITÉ DU DÉTECTEUR / VÉLOCITÉ DU DÉTECTEUR DE GAINE'
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'bruit',
              label: 'BRUIT AMBIANT'
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'bruitA',
              label: 'BRUIT EN ALARME'
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'deficiences',
              label: 'DÉFICIENCES ET/OU REMARQUES (VOIR SECTIONS 1-2-3)'
            }
            ]}
            fields={[
              {
                fieldType: Input,
                props: {
                  name: 'emplacement_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'model_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'ic_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'manquant_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'rn_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'fc_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'sc_'
                }
              }, {
                fieldType: Select,
                props: {
                  name: 'dispositif_',
                  options: DispositifList(),
                  onBlur: this.handleUpdateRegistryFromTableCount,
                  search: true,
                  defaultValue: ''
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'za_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'sensi_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'bruitAmbiant_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'bruitAlarme_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'defRemarque_'
                }
              }
            ]}
          />

        </Section>
        <Section title={(<Header as='h2'>FICHE DE MISE À L'ESSAI DU POSTE DE CONTRÔLE INCENDIE</Header>)}>
          <Form.Group widths='equal'>
            <Input name='emplacementPoste' formEntry={equipment} label='Emplacement du poste de contrôle ou du répondeur' />
            <Input name='identificationPoste' formEntry={equipment} label='Identification du poste de contrôle ou du répondeur' />
          </Form.Group>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de l'indicateur visuel de mise sous tension</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du signal de défectuosité visuel commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du signal de défectuosité sonore commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>D</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de l'interrupteur de signalisation sonore de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>E</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du signal de défectuosité de l'alimentation principale</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>F</Grid.Column>
              <Grid.Column width={9}>Fuite à la terre sur signal de défectuosité positif et négatif</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>G</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du signal d'alerte</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>H</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du signal d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>I</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du passage automatique de signal d'alerte à signal d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>J</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du passage manuel de signal d'alerte à signal d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>K</Grid.Column>
              <Grid.Column width={9}>Caractéristique (accusé de réception) d'annulation du passage automatique de signal d'alerte à signal d'alarme fonctionnant sur un réseau à deux étapes</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>L</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de la désactivation de l'interruption du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_l' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>M</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de l'interruption manuelle du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_m' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>N</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de l'indicateur visuel d'interruption du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_n' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>O</Grid.Column>
              <Grid.Column width={9}>Déclenchement automatique du signal d'alarme sonore, après interruption, en cas de réception d'alarme subséquente</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_o' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>P</Grid.Column>
              <Grid.Column width={9}>Temporisation automatique d'annulation du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_p' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>Q</Grid.Column>
              <Grid.Column width={9}>Signaux d'alerte et d'alarme sonores et visuels programmés et fonctionnant conformément à la conception et aux spécifications</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_q' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_q' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_q' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>R</Grid.Column>
              <Grid.Column width={9}>Fonctionnement d'alarme et de surveillance du circuit d'entrée, y compris les indications sonores et visuelles</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_r' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_r' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_r' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>S</Grid.Column>
              <Grid.Column width={9}>La surveillance des défauts sur un circuit d'entrée entraîne une indication de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_s' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>T</Grid.Column>
              <Grid.Column width={9}>Fonctionnement des indicateurs d'alarme du circuit de sortie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_t' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>U</Grid.Column>
              <Grid.Column width={9}>La surveillance des défauts sur un circuit de sortie entraîne une indication de défecuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_u' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>V</Grid.Column>
              <Grid.Column width={9}>Essai d'indicateur visuel (essai de lampe)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_v' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_v' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_v' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>W</Grid.Column>
              <Grid.Column width={9}>Séquences de signal codé fonctionnant au moins le nombre de fois nécessaire et suivie d'un déclenchement de signal d'alarme approprié</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_w' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_w' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_w' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>X</Grid.Column>
              <Grid.Column width={9}>Séquences de signal codé fonctionnant au moins le nombre de fois nécessaire et suivie d'un déclenchement de signal d'alarme approprié</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_x' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_x' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_x' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>Y</Grid.Column>
              <Grid.Column width={9}>Une dérivation du dispositif auxiliaire provoquant un signal de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_y' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_y' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_y' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>Z</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du circuit d'entrée vers le circuit de sortie, y compris les circuits des dispositifs auxiliaires pour assurer le bon fonctionnement du programme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_z' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_z' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_z' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>AA</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du réarmement du réseau avertisseur d'incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aa' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aa' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aa' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>BB</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de la commutation de l'alimentation principale à l'alimentation de secours</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_bb' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_bb' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_bb' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>CC</Grid.Column>
              <Grid.Column width={9}>Vérification de la confirmation du changement d'état (détecteurs de fumée seulement)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_cc' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_cc' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_cc' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>DD</Grid.Column>
              <Grid.Column width={9}>Réception de la transmission d'un signal d'alarme à la centrale de réception d'alarme incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_dd' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_dd' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_dd' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>EE</Grid.Column>
              <Grid.Column width={9}>Réception de la transmission d'un signal de surveillance à la centrale de réception d'alarme incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ee' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ee' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ee' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>FF</Grid.Column>
              <Grid.Column width={9}>Réception de la transmission d'un signal de défectuosité à la centrale de réception d'alarme incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ff' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ff' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ff' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>GG</Grid.Column>
              <Grid.Column width={9}>Nom et numéro de téléphone de la centrale de réception d'alarme incendie ainsi que le numéro de liaison</Grid.Column>
              <Grid.Column width={6}>
                <Input name='name_gg' formEntry={equipment} label='Nom:' />
                <Input name='tel_gg' formEntry={equipment} label='Tél:' />
                <Input name='noli_gg' formEntry={equipment} label='No de liaison:' />
                <Input name='op_gg' formEntry={equipment} label='Opérateur:' />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>HH</Grid.Column>
              <Grid.Column width={9}>Le déclenchement du sectionneur de la centrale de réception d'alarme incendie produit une indication de défectuosité précise au poste de contrôle ou au répondeur et achemine un signal de défectuosité à la centrale de réception d'alarme incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_hh' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_hh' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_hh' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>ESSAI DE COMMUNICATION PHONIQUE</Header>)} name='phoneSO' equipment={equipment}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de l'indicateur de mise sous tension</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du signal de défectuosité visuel commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du signal de défectuosité sonore commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>D</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de l'interrupteur de signalisation sonore de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>E</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de la recherche phonique générale de personnes, y compris l'indication visuelle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>F</Grid.Column>
              <Grid.Column width={9}>Fonctionnement des circuits de sortie en cas de recherche phonique sélective de personnes, y compris l'indication visuelle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>G</Grid.Column>
              <Grid.Column width={9}>Fonctionnement des circuits de sortie pour défectuosité de recherche phonique sélective de personnes, y compris l'indication visuelle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>H</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du microphone, y compris bouton de communication</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>I</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de la recherche de personnes ne nuisant pas à la temporisation initiale de désactivation de la signalisation sonore d'alerte ou d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>J</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de la recherche générale de personnes (en alimentation de secours seulement)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>K</Grid.Column>
              <Grid.Column width={9}>Passage automatique à un amplificateur de relève en cas de panne d'un amplificateur normal</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>L</Grid.Column>
              <Grid.Column width={9}>Circuits de réception d'appel d'un téléphone d'urgence; y compris les indications sonores et visuelles</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_l' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>M</Grid.Column>
              <Grid.Column width={9}>Fonctionnement des circuits des téléphones d'urgence, y compris les communications phoniques bidirectionnelles</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_m' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>N</Grid.Column>
              <Grid.Column width={9}>Fonctionnement des circuits de signalisation de défectuosité des téléphones d'urgence, y compris l'indication visuelle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_n' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>O</Grid.Column>
              <Grid.Column width={9}>Fonctionnement des communications verbales par téléphone d'urgence</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_o' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>P</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de la tonalité d'utilisation ou de disponibilité des téléphones d'urgence, au combiné</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ph_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ph_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ph_p' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>INSPECTION DU POSTE DE CONTRÔLE OU DU RÉPONDEUR</Header>)}>
          <Duplicate
            name='idpdcodrList' btnLabel='Poste de contrôle ou du répondeur' equipment={equipment} renderGroup={(index) => {
              return (
                <Fragment key={`idpdcodr_${index}`}>
                  <Header as='h5'>Inspection du poste de contrôle ou du répondeur #{index + 1}</Header>
                  <Input name={`emplacementpc${index || ''}`} formEntry={equipment} label='Emplacement du poste de contrôle ou du répondeur' />
                  <Grid celled>
                    <Grid.Row>
                      <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
                      <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
                      <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
                      <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>A</Grid.Column>
                      <Grid.Column width={9}>Désignations du circuit d'entrée correctement indiquées et correspondant aux dipositifs raccordés</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_pc_a${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_pc_a${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_pc_a${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>B</Grid.Column>
                      <Grid.Column width={9}>Désignations du circuit de sortie correctement repérées et correspondants à celles des dispositifs raccordés</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_pc_b${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_pc_b${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_pc_b${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>C</Grid.Column>
                      <Grid.Column width={9}>Désignations des fonctions de contrôle communes et des indicateurs communs correctes</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_pc_c${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_pc_c${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_pc_c${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>D</Grid.Column>
                      <Grid.Column width={9}>Composants enfichables et modules solidement en place</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_pc_d${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_pc_d${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_pc_d${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>E</Grid.Column>
                      <Grid.Column width={9}>Câbles enfichables solidement en place</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_pc_e${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_pc_e${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_pc_e${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>F</Grid.Column>
                      <Grid.Column width={9}>Date, révisions et versions des microprogrammes et des programmes logiciels consignées</Grid.Column>
                      <Grid.Column width={6}>
                        <Input name={`date_pc_f${index || ''}`} formEntry={equipment} label='Date:' />
                        <Input name={`rev_pc_f${index || ''}`} formEntry={equipment} label='Rév:' />
                        <Input name={`vers_pc_f${index || ''}`} formEntry={equipment} label='Vers:' />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>G</Grid.Column>
                      <Grid.Column width={9}>Propre et exempt de poussière et de saleté</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_pc_g${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_pc_g${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_pc_g${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>H</Grid.Column>
                      <Grid.Column width={9}>Fusibles conformes aux spécifications des fabricants</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_pc_h${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_pc_h${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_pc_h${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>I</Grid.Column>
                      <Grid.Column width={9}>Verrouillage du poste de contrôle ou du répondeur</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_pc_i${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_pc_i${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_pc_i${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>J</Grid.Column>
                      <Grid.Column width={9}>Solidité des connexions du câblage aux dispositifs</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_pc_j${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_pc_j${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_pc_j${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Fragment>
              )
            }}
          />
        </Section>
        <Section title={(<Header as='h2'>INSPECTION DE L'ALIMENTATION</Header>)} name='inspection_al_so' equipment={equipment}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={9}>Protection fusible correspondant aux caractéristiques nominales affichées par le fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_al_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_al_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_al_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={9}>Alimentation suffisante pour les besoins du réseau</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_al_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_al_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_al_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE À L'ESSAI ET INSPECTION DE L'ALIMENTATION DE SECOURS</Header>)}>
          <Duplicate
            name='meiasList' btnLabel='Alimentation de secours' equipment={equipment} renderGroup={(index) => {
              return (
                <Fragment key={`meias${index}`}>
                  <Header as='h5'>Mise à l'essai et inspection de l'alimentation de secours #{index + 1}</Header>
                  <Form.Group widths='equal'>
                    <Input name={`alimentationSystemIncendie${index || ''}`} formEntry={equipment} label='Système incendie' />
                    <Input name={`alimentationAnnonciateur${index || ''}`} formEntry={equipment} label='Annonciateur' />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Input name={`alimentationAmplificateur${index || ''}`} formEntry={equipment} label='Amplificateur' />
                    <Input name={`alimentationAutre${index || ''}`} formEntry={equipment} label='Autre' />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Input name={`alimentationGeneratrice${index || ''}`} formEntry={equipment} label='Système relié à une génératrice' />
                    <Input name={`alimentationBatteries${index || ''}`} formEntry={equipment} label='Valeur nominale des batteries en place (Ah)' />
                  </Form.Group>
                  <Grid celled>
                    <Grid.Row>
                      <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
                      <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
                      <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
                      <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>A</Grid.Column>
                      <Grid.Column width={9}>Type de batterie recommandé par le fabricant</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_a${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_a${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_a${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>B</Grid.Column>
                      <Grid.Column width={9}>Recherche de dommages matériaux état physique intact</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_b${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_b${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_b${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>C</Grid.Column>
                      <Grid.Column width={9}>Bornes nettoyées et lubrifiées</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_c${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_c${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_c${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>D</Grid.Column>
                      <Grid.Column width={9}>Bornes serrées</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_d${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_d${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_d${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>E</Grid.Column>
                      <Grid.Column width={9}>Niveau d'électrolyte correct</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_e${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_e${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_e${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>F</Grid.Column>
                      <Grid.Column width={9}>Densité de l'électrolyte conforme aux spécifications du fabricant</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_f${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_f${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_f${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>G</Grid.Column>
                      <Grid.Column width={9}>Absence de fuite d'électrolyte</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_g${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_g${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_g${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>H</Grid.Column>
                      <Grid.Column width={9}>Ventilation adéquate</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_h${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_h${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_h${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>I</Grid.Column>
                      <Grid.Column width={9}>Code dateur du fabricant ou date de mise en service</Grid.Column>
                      <Grid.Column width={6}>
                        <Input name={`codeDateur_as_i${index || ''}`} formEntry={equipment} label='Code dateur' />
                        <Input name={`date_as_i${index || ''}`} formEntry={equipment} label='Date' />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>J</Grid.Column>
                      <Grid.Column width={9}>Débranchement provoque signal de défectuosité</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_j${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_j${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_j${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>K</Grid.Column>
                      <Grid.Column width={15}>Indiquer le type d'essai de batterie exécuté</Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>K (I)</Grid.Column>
                      <Grid.Column width={9}>Essai silencieux accéléré</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_k1${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_k1${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_k1${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>K (II)</Grid.Column>
                      <Grid.Column width={9}>Essai de capacimètre de batterie</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_k2${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_k2${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_k2${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>K (III)</Grid.Column>
                      <Grid.Column width={9}>Au lieu d'exécuter les essais décrits ci-dessus, remplacer la batterie par un type de batterie recommandé par le fabricant, doté d'un code dateur courant et d'une capacité nominale en ampère-heure</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_k3${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_k3${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_k3${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>L</Grid.Column>
                      <Grid.Column width={9}>Emplacement du disjoncteur et identification</Grid.Column>
                      <Grid.Column width={6}>
                        <Input name={`emplacement_dij_j${index || ''}`} formEntry={equipment} />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>M</Grid.Column>
                      <Grid.Column width={9}>Lecture de conductivité interne</Grid.Column>
                      <Grid.Column width={6}>
                        <Input name={`pour_as_m${index || ''}`} formEntry={equipment} label='Pourcentage' />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>N</Grid.Column>
                      <Grid.Column width={9}>Tension de batterie lorsque la source d'alimentation principale est sous tension</Grid.Column>
                      <Grid.Column width={6}>
                        <Input name={`tens_as_n${index || ''}`} formEntry={equipment} label='Tension (Vcc)' />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>O</Grid.Column>
                      <Grid.Column width={9}>Courant de charge</Grid.Column>
                      <Grid.Column width={6}>
                        <Input name={`cour_as_o${index || ''}`} formEntry={equipment} label='Courant (A)' />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>P</Grid.Column>
                      <Grid.Column width={9}>Tension et courant de batterie, alimentation principale coupée et réseau avertisseur d'incendie en mode surveillance</Grid.Column>
                      <Grid.Column width={6}>
                        <Input name={`tens_as_p${index || ''}`} formEntry={equipment} label='Tension (Vcc)' />
                        <Input name={`cour_as_p${index || ''}`} formEntry={equipment} label='Courant (A)' />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>Q</Grid.Column>
                      <Grid.Column width={9}>Tension et courant de batterie, alimentation principale coupée et réseau avertisseur d'incendie en pleine charge d'alarme</Grid.Column>
                      <Grid.Column width={6}>
                        <Input name={`tens_as_q${index || ''}`} formEntry={equipment} label='Tension (Vcc)' />
                        <Input name={`cour_as_q${index || ''}`} formEntry={equipment} label='Courant (A)' />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>R</Grid.Column>
                      <Grid.Column width={9}>À la fin des essais consigner la tension aux bornes de la batterie</Grid.Column>
                      <Grid.Column width={6}>
                        <Input name={`tens_as_r${index || ''}`} formEntry={equipment} label='Tension (Vcc)' />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>S</Grid.Column>
                      <Grid.Column width={9}>À la fin des essais la tension de batterie est supérieure à 85% de la tension nominale</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_s${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_s${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_s${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>T</Grid.Column>
                      <Grid.Column width={9}>Consigner la capacité calculé</Grid.Column>
                      <Grid.Column width={6}>
                        <Input name={`cap_as_t${index || ''}`} formEntry={equipment} label='Capacité (Ah)' />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>U</Grid.Column>
                      <Grid.Column width={9}>Caractéristique nomimale suffisantes d'après des calculs fondés sur la pleine charge du réseau</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_as_u${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_as_u${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_as_u${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Fragment>
              )
            }}
          />
        </Section>
        <Section title={(<Header as='h2'>INSPECTION DE L'ALIMENTATION</Header>)} name='inspection_alas_so' equipment={equipment}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={9}>Protection fusible correspondant aux caractéristiques nominales affichées par le fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_alas_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_alas_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_alas_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={9}>Alimentation suffisante pour les besoins du réseau</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_alas_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_alas_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_alas_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE À L'ESSAI ET INSPECTION DE L'ANNONCIATEUR ET DE L'INDICATEUR DE DÉFECTUOSITÉ À DISTANCE</Header>)} name='inspection_ad_so' equipment={equipment}>
          <Duplicate
            name='meiaiddList' btnLabel='Indicateur de défectuosité' equipment={equipment} renderGroup={(index) => {
              return (
                <Fragment key={`meiaidd${index}`}>
                  <Header as='h5'>Mise à l'essai et inspection de l'annonciateur et de l'indicateur de défectuosité à distance #{index + 1}</Header>
                  <Form.Group widths='equal'>
                    <Input name={`inspection_ad_emplacement${index || ''}`} formEntry={equipment} label={"Emplacement de l'annonciateur ou de l'indicateur de défectuosité à distance"} />
                    <Input name={`inspection_ad_identification${index || ''}`} formEntry={equipment} label={"Identification de l'annonciateur ou de l'indicateur de défectuosité à distance"} />
                  </Form.Group>
                  <Grid celled>
                    <Grid.Row>
                      <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
                      <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
                      <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
                      <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>A</Grid.Column>
                      <Grid.Column width={9}>Fonctionnement de l'indicateur de mise sous tension</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_a${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_a${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_a${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>B</Grid.Column>
                      <Grid.Column width={9}>Zones d'entrées individuelles d'alarme et de surveillance indiquées clairement, de manière distincte</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_b${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_b${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_b${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>C</Grid.Column>
                      <Grid.Column width={9}>Étiquettes de désignation des zones individuelles d'alarme et de surveillance correctement marquées</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_c${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_c${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_c${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>D</Grid.Column>
                      <Grid.Column width={9}>Fonctionnement du signal de défectuosité commun</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_d${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_d${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_d${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>E</Grid.Column>
                      <Grid.Column width={9}>Fonctionnement de l'essai d'indicateur visuel (essai de lampe)</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_e${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_e${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_e${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>F</Grid.Column>
                      <Grid.Column width={9}>Surveillance du câblage d'entrée du poste de contrôle ou du répondeur</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_f${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_f${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_f${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>G</Grid.Column>
                      <Grid.Column width={9}>Fonctionnement de l'indicateur visuel d'interruption du signal d'alarme sonore</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_g${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_g${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_g${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>H</Grid.Column>
                      <Grid.Column width={9}>Contacts de fonctions auxiliaires fonctionnant conformément à la conception et aux spécifications</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_h${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_h${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_h${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>I</Grid.Column>
                      <Grid.Column width={9}>Fonctionnement des autres indicateurs visuels des fonctions auxiliaires</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_i${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_i${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_i${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>J</Grid.Column>
                      <Grid.Column width={9}>Actionnement manuel du signal d'alarme et indication</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_j${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_j${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_j${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>K</Grid.Column>
                      <Grid.Column width={9}>Affichages visibles dans le lieu de l'installation</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_k${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_k${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_k${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1}>L</Grid.Column>
                      <Grid.Column width={9}>Fonctionnement sur alimentation de secours</Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`yes_ad_l${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`no_ad_l${index || ''}`} formEntry={equipment} /></Grid.Column>
                      <Grid.Column width={2}><Checkbox name={`so_ad_l${index || ''}`} formEntry={equipment} /></Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Fragment>
              )
            }}
          />
        </Section>
        <Section title={(<Header as='h2'>ANNONCIATEURS OU AFFICHAGES SÉQUENTIELS</Header>)} name='inspection_aas_so' equipment={equipment}>
          <Input name='inspection_aas_emplacement' formEntry={equipment} label='Emplacement' />
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de l'indicateur de mise sous tension</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={9}>Zones d'entrées individuelles d'alarme et de surveillance indiquées clairement, de manière distincte</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_b1' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_b1' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_b1' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B (I)</Grid.Column>
              <Grid.Column width={9}>Exception: l'indication de zone individuelle d'alarme et de surveillance donnera la même indication ou allumera les mêmes indicateurs sur le ou les autres annonciateurs et affichages séquentiels.</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_b2' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_b2' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_b2' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B (II)</Grid.Column>
              <Grid.Column width={9}>Préciser la méthode de confirmation:</Grid.Column>
              <Grid.Column width={6}>
                <Input name='yes_aas_b3' formEntry={equipment} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B (III)</Grid.Column>
              <Grid.Column width={9}>Pour confirmer le bon fonctionnement des zones d'alarme et de surveillance, il faut mettre à l'essai au moins une zone d'alarme et de surveillance par annonciateur ou affichage séquentiel</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_b4' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_b4' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_b4' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={9}>Étiquettes de désignation des zones individuelles d'alarme et de surveillance correctement marquées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>D</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du signal de défectuosité commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>E</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de l'essai d'indicateur visuel (essai de lampe)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>F</Grid.Column>
              <Grid.Column width={9}>Surveillance du câblage d'entrée du poste de contrôle ou du répondeur</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>G</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de l'indicateur visuel d'interruption du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>H</Grid.Column>
              <Grid.Column width={9}>Contacts de fonctions auxiliaires fonctionnant conformément à la conception et aux spécifications</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>I</Grid.Column>
              <Grid.Column width={9}>Fonctionnement des autres indicateurs visuels des fonctions auxiliaires</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>J</Grid.Column>
              <Grid.Column width={9}>Actionnement manuel du signal d'alarme et indication</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>K</Grid.Column>
              <Grid.Column width={9}>Affichages visibles dans le lieu de l'installation</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_aas_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_aas_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_aas_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE À L'ESSAI ET INSPECTION DE L'INDICATEUR DE DÉFECTUOSITÉ À DISTANCE</Header>)} name='inspection_iid_so' equipment={equipment}>
          <Input name='inspection_iid_emplacement' formEntry={equipment} label='Emplacement' />
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={9}>Surveillance du câblage d'entrée du poste de contrôle ou du répondeur</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iid_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iid_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iid_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du signal visuel de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iid_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iid_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iid_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={9}>Fonctionnement du signal sonore de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iid_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iid_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iid_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>D</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de l'interruption du signal sonore de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iid_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iid_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iid_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE À L'ESSAI DE L'IMPRIMANTE</Header>)} name='inspection_mei_so' equipment={equipment}>
          <Input name='inspection_mei_emplacement' formEntry={equipment} label='Emplacement' />
          <Form.Group widths='equal'>
            <Input name='inspection_mei_emplacementImprimante' formEntry={equipment} label="Emplacement de l'imprimante" />
            <Input name='inspection_mei_identificationImprimante' formEntry={equipment} label="Identification de l'imprimante" />
          </Form.Group>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={9}>Fonctionnement de l'imprimante selon la conception et les spécifications</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mei_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mei_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mei_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={9}>Impression correcte de la zone de chaque dispositif de déclenchement d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mei_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mei_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mei_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={9}>Alimentation à la tension nominale</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mei_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mei_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mei_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE À L'ESSAI DE LA LIAISON DE DONNÉES</Header>)} name='inspection_mld_so' equipment={equipment}>
          <Input name='inspection_mld_emplacement' formEntry={equipment} label='Identification de la liaison de données' />
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={9}>Confirmer la réception d'un signal de défectuosité par le poste de contrôle ou le répondeur en cas de boucle ouverte pour chaque liaison de données</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mld_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mld_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mld_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={9}>Si des modules d'isolation en cas de défaut font parti des liaisons de données desservant des dispositifs, court-circuiter le câblage du côté isolé et confirmer l'annonce de la défectuosité; faire ensuite fonctionner un dispositif du côté source et confirmer l'activation au poste de contrôle ou au répondeur</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mld_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mld_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mld_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={9}>Si l'isolation en cas de défaut des liaisons de données est assurée entre les postes de contrôle ou les répondeurs et entre des répondeurs, créer un court-circuit et confirmer l'annonce de la défectuosité et le fonctionnement à l'extérieur de la section court-circuitée entre chaque paire de:</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mld_c1' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mld_c1' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mld_c1' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C (I)</Grid.Column>
              <Grid.Column width={9}>Poste de contrôle et poste de contrôle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mld_c2' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mld_c2' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mld_c2' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C (II)</Grid.Column>
              <Grid.Column width={9}>Poste de contrôle et répondeur</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mld_c3' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mld_c3' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mld_c3' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C (III)</Grid.Column>
              <Grid.Column width={9}>Répondeur et répondeur</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mld_c4' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mld_c4' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mld_c4' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE À L'ESSAI DU CIRCUIT DU DISPOSITIF AUXILIAIRE</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10} />
              <Grid.Column width={6} textAlign='center'>
                <Header as='h5'>Confirmation du fonctionnement du circuit du dispositif auxiliaire</Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10} textAlign='center'>
                <Header as='h5'>Consigner le type particulier de circuit du dispositif auxiliaire</Header>
              </Grid.Column>
              <Grid.Column width={2} textAlign='center'><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2} textAlign='center'><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2} textAlign='center'><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            {[...Array(8)].map((value, index) => (
              <Grid.Row key={`cda${index}`} className='compact'>
                <Grid.Column width={10} className='compact'><Input name={`text_cda_a${index + 1}`} size='mini' formEntry={equipment} /></Grid.Column>
                <Grid.Column width={2} textAlign='center'><Checkbox name={`yes_cda_a${index + 1}`} formEntry={equipment} /></Grid.Column>
                <Grid.Column width={2} textAlign='center'><Checkbox name={`no_cda_a${index + 1}`} formEntry={equipment} /></Grid.Column>
                <Grid.Column width={2} textAlign='center'><Checkbox name={`so_cda_a${index + 1}`} formEntry={equipment} /></Grid.Column>
              </Grid.Row>
            ))}
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>LACUNES (SECTION #1)</Header>)}>
          <TableDnD
            formEntry={equipment}
            tableProps={{ celled: true, compact: 'very', size: 'small', style: { minWidth: '800px!important' } }}
            totalRowLabel='tableLacuneRows'
            addRowLabel='Ajouter X nombre de lacunes supplémentaires'
            droppableKey='tableLacune'
            startingRowIndex={19}
            staticRows={[
              <Fragment key='tableLacuneD1'>
                <Table.Cell><Checkbox name='check_lacune_d1' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D1</strong></Table.Cell>
                <Table.Cell>Ce dispositif est défectueux. Il devra être remplacé. (ULC-S-536-04 section 5.7.1)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD2'>
                <Table.Cell><Checkbox name='check_lacune_d2' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D2</strong></Table.Cell>
                <Table.Cell>Ce dispositif est mal fixé. (ULC-S-536-04 section 5.7.1)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD3'>
                <Table.Cell><Checkbox name='check_lacune_d3' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D3</strong></Table.Cell>
                <Table.Cell>Pour des raisons de sécurité, ce dispositif n'a pas été mis a l'essai pour une deuxième année consécutives. (ULC-S-536-04 section 5.7.1.3)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD4'>
                <Table.Cell><Checkbox name='check_lacune_d4' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D4</strong></Table.Cell>
                <Table.Cell>Nous n'avons pas eu accès à ce local pour effectuer l'essai de ce dispositif. (ULC-S-536-04 section 5.7.1.3)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD5'>
                <Table.Cell><Checkbox name='check_lacune_d5' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D5</strong></Table.Cell>
                <Table.Cell>Ce dispositif est endommagé et devra être remplacé. (ULC-S-536-04 section 5.7.1.1)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD6'>
                <Table.Cell><Checkbox name='check_lacune_d6' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D6</strong></Table.Cell>
                <Table.Cell>Ce dispositif est peint et devra être remplacé. (ULC-S-536-04 section 5.7.1.1 B)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD7'>
                <Table.Cell><Checkbox name='check_lacune_d7' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D7</strong></Table.Cell>
                <Table.Cell>Ce dispositif n'est plus raccordé sur le système. (ULC-S-536-04 section 5.7.1.2)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD8'>
                <Table.Cell><Checkbox name='check_lacune_d8' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D8</strong></Table.Cell>
                <Table.Cell>La description de la zone ou du dispositif est erroné. Elle doit être corrigée. (C.N.B. - 2010 section 3.2.4.9)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD9'>
                <Table.Cell><Checkbox name='check_lacune_d9' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D9</strong></Table.Cell>
                <Table.Cell>Ce dispositif est obstrué et l'obstacle empêche le bon fonctionnement du dispositif. (ULC-S-524-06 section 5.7.2.2)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD10'>
                <Table.Cell><Checkbox name='check_lacune_d10' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D10</strong></Table.Cell>
                <Table.Cell>Ce dispositif est installé dans le mur ou le plafond. Il doit être relocalisé. (ULC-S-524-06 section 5.7.2)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD11'>
                <Table.Cell><Checkbox name='check_lacune_d11' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D11</strong></Table.Cell>
                <Table.Cell>Il manque des tuiles au plafond. Cela nuit à la détection d'incendie. (ULC-S-524-06 section 5.7.2)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD12'>
                <Table.Cell><Checkbox name='check_lacune_d12' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D12</strong></Table.Cell>
                <Table.Cell>Il n'y a pas eu d'essai des dispositifs sonores. (ULC-S-536-04 section 5.7.9)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD13'>
                <Table.Cell><Checkbox name='check_lacune_d13' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D13</strong></Table.Cell>
                <Table.Cell>Le système de ventillation ne s'arrête pas lors d'un alarme incendie. (C.N.B. - 2010 section 3.2.4.13)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD14'>
                <Table.Cell><Checkbox name='check_lacune_d14' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D14</strong></Table.Cell>
                <Table.Cell>Les électro-aimant ou retenue de porte ne sont pas relâché lors d'un alarme incendie. (C.N.B. - 2010 section 3.4.6.16)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD15'>
                <Table.Cell><Checkbox name='check_lacune_d15' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D15</strong></Table.Cell>
                <Table.Cell>Les batteries sont défectueuse et devront être remplacées. (ULC-S-536-04 section 5.3.2)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD16'>
                <Table.Cell><Checkbox name='check_lacune_d16' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D16</strong></Table.Cell>
                <Table.Cell>Les batteries n'ont pas la capacité suffisante pour supporter la charge. (C.N.B. - 2010 section 5.3.2)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD17'>
                <Table.Cell><Checkbox name='check_lacune_d17' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D17</strong></Table.Cell>
                <Table.Cell>Le filage n'est pas supervisé. (ULC-S-524-06 section 3.3)</Table.Cell>
              </Fragment>,
              <Fragment key='tableLacuneD18'>
                <Table.Cell><Checkbox name='check_lacune_d18' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D18</strong></Table.Cell>
                <Table.Cell>Le bâtiment doit être relié à une centrale d'alarme (C.N.B. 2005 section 3,2,4,7)</Table.Cell>
              </Fragment>
            ]}
            fields={[
              {
                fieldType: Checkbox,
                props: {
                  name: 'check_lacune_d'
                }
              }, {
                fieldType: 'strong',
                props: { prefix: 'D' }
              }, {
                fieldType: Input,
                props: {
                  name: 'text_lacune_d'
                }
              }
            ]}
          />
        </Section>
        <Section title={(<Header as='h2'>RECOMMANDATION (SECTION #2)</Header>)}>
          <Table celled compact='very' size='small' style={{ minWidth: '800px!important' }}>
            <Table.Body>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r36' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R1</strong></Table.Cell>
                <Table.Cell>Ce détecteur est installé a moin de 10 cm d'un mur. (ULC-S-524-06 section 5.7.2.3)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r2' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R2</strong></Table.Cell>
                <Table.Cell>Il y a de la condensation sur ce dispositif, ceci pourrait affecter son fonctionnement.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r3' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R3</strong></Table.Cell>
                <Table.Cell>Ce dispositif n'est pas approuvé ULC.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r4' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R4</strong></Table.Cell>
                <Table.Cell>Un détecteur de chaleur devrait être ajouté à cet endroit.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r5' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R5</strong></Table.Cell>
                <Table.Cell>Un détecteur de fumée devrait être ajouté à cet endroit.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r6' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R6</strong></Table.Cell>
                <Table.Cell>Une station manuelle devrait être ajouté à cet endroit.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r7' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R7</strong></Table.Cell>
                <Table.Cell>Un détecteur de chaleur devrait être remplacé pas un détecteur de fumée.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r8' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R8</strong></Table.Cell>
                <Table.Cell>Ce dispositif n'est pas a son point le plus haut.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r9' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R9</strong></Table.Cell>
                <Table.Cell>Il y a trop de vélocité près de ce détecteur.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r10' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R10</strong></Table.Cell>
                <Table.Cell>Ce détecteur est installé au mur.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r11' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R11</strong></Table.Cell>
                <Table.Cell>Ce dispositif devrait être sur une zone séparé.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r12' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R12</strong></Table.Cell>
                <Table.Cell>Ce détecteur de fumée devrait être remplacé par un détecteur de chaleur.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r13' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R13</strong></Table.Cell>
                <Table.Cell>Cette station manuelle est trop loin de l'issue de secours. (plus de 5 pieds)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r14' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R14</strong></Table.Cell>
                <Table.Cell>Ce dispositif devrait avoir un protecteur pour empêcher qu'il soit endommagé.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r15' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R15</strong></Table.Cell>
                <Table.Cell>Cette station manuelle n'est pas installé à la bonne hauteur.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r16' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R16</strong></Table.Cell>
                <Table.Cell>La tige de verre est manquante sur cette station manuelle.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r17' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R17</strong></Table.Cell>
                <Table.Cell>Le niveau sonore n'est pas suffisant dans cette pièce.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r18' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R18</strong></Table.Cell>
                <Table.Cell>Un avertisseur visuel est manquant dans cette pièce.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r19' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R19</strong></Table.Cell>
                <Table.Cell>Plusieur types d'alarme sont entendu lors d'un alarme.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r20' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R20</strong></Table.Cell>
                <Table.Cell>L'aspirateur centrale n'est pas reliée au panneau incendie.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r21' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R21</strong></Table.Cell>
                <Table.Cell>Les portes d'accès ne sont pas reliée au panneau incendie.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r22' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R22</strong></Table.Cell>
                <Table.Cell>La génératrice ne transmet pas de signaux au panneau incendie.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r23' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R23</strong></Table.Cell>
                <Table.Cell>Le disjoncteur 120v n'est pas vérouillé.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r24' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R24</strong></Table.Cell>
                <Table.Cell>Le disjoncteur 120v n'est pas peint en rouge.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r25' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R25</strong></Table.Cell>
                <Table.Cell>Le filage n'est pas conforme.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r26' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R26</strong></Table.Cell>
                <Table.Cell>Mise a la terre manquante.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r27' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R27</strong></Table.Cell>
                <Table.Cell>La fin de ligne n'est pas dans un boitier séparé.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_recommandation_r28' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R28</strong></Table.Cell>
                <Table.Cell>La centrale d'alarme ne recoit pas de signal.</Table.Cell>
              </Table.Row>
              {[...Array(6)].map((row, index) => (
                <Table.Row key={`tableRowRe${index}`}>
                  <Table.Cell><Checkbox name={`check_recommandation_r${index + 29}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><strong>R{index + 29}</strong></Table.Cell>
                  <Table.Cell><Input name={`text_recommandation_r${index + 29}`} formEntry={equipment} /></Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Section>
        <Section title={(<Header as='h2'>REMARQUE (SECTION #3)</Header>)}>
          <Table celled compact='very' size='small' style={{ minWidth: '800px!important' }}>
            <Table.Body>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r35' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R35</strong></Table.Cell>
                <Table.Cell>Ce dispositif est débranché, le secteur est en construction.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r36' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R36</strong></Table.Cell>
                <Table.Cell>Nous n'avons pas localisé cette équipement.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r37' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R37</strong></Table.Cell>
                <Table.Cell>Un technicien d'ascenceur est requis pour inspecter cette équipement.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r38' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R38</strong></Table.Cell>
                <Table.Cell>Ce détecteur a été vérifié électriquement.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r39' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R39</strong></Table.Cell>
                <Table.Cell>Ce détecteur est a déclenchement unique.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r40' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R40</strong></Table.Cell>
                <Table.Cell>Le système de ventillation n'était pas en service lors de l'inspection, cependant le relais fonctionne.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r41' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R41</strong></Table.Cell>
                <Table.Cell>Un technicien de gicleur est requis pour inspecter cette équipement.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r42' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R42</strong></Table.Cell>
                <Table.Cell>Un technicien de génératrice est requis pour inspecter cette équipement.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r43' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R43</strong></Table.Cell>
                <Table.Cell>La sensibilité indiquée dans la colonne '' note '' est celle fournie par le panneau.</Table.Cell>
              </Table.Row>
              {[...Array(5)].map((row, index) => (
                <Table.Row key={`tableRowRem${index}`}>
                  <Table.Cell><Checkbox name={`check_remarque_r${index + 44}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><strong>R{index + 44}</strong></Table.Cell>
                  <Table.Cell><Input name={`text_remarque_r${index + 44}`} formEntry={equipment} /></Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Section>
        <Section title={(<Header as='h2'>EXPLICATION DES LACUNES</Header>)}>
          <Table celled compact='very' size='small' style={{ minWidth: '800px!important' }}>
            <Table.Body>
              {[...Array(32)].map((row, index) => (
                <Table.Row key={`tableRowExL${index + 1}`}>
                  <Table.Cell><Input name={`text_explicationLacune_${index + 1}`} formEntry={equipment} /></Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Section>
      </Form>
    )
  }
}

export default RIA53604000
